import React from "react";
import "../Styles/Courses.css";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

const CourseHeader = ({ header, btnName, icon, redirectTo, onclick,btnValue}) => {
  const navigate = useNavigate();

  const handleRedirectTo = () => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  };

  const combinedOnClick = () => {
    if (redirectTo) {
      handleRedirectTo(); // Navigate if redirectTo is provided
    }
    if (onclick) {
      onclick(); // Call the passed onClick handler (if any)
    }
  };

  const getButtonText = () => {
    if (btnValue) {
      return (
        <>
          <ArrowLeftOutlined style={{ marginRight: 8 }} />
          {btnName}
        </>
      )
    } else {
      return `+ ${btnName}`;
    }
  };

  return (
    <div className={`courses_header_card w-100`}>
      <div>
        {icon && <img src={icon} alt="Header Icon" className="header_icon" />}
        {header}
      </div>
      {btnName && (
        <div>
          <button className="add_course_btn" onClick={combinedOnClick}>
          {getButtonText()}
          </button>
        </div>
      )}
    </div>
  );
};

export default CourseHeader;
